<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Weapons of Our Warfare</title>
<section epub:type="contributors">
<h1 class="ct"><span epub:type="pagebreak" id="page_v" title="v"><a href="#/contenttoc#ft-1" id="front-1">FOREWORD</a></span></h1>
<p class="tx1">I’<span class="small">M THANKFUL TO</span> be married to a pastor who stands boldly through all the deception and controversy in these evil days. His courage and wisdom in writing this timely book have encouraged me greatly. I believe it will take all who read it through a spiritual boot camp—the urgently needed equipping and training for the army of God. We are undoubtedly living in the last days—days where lawlessness is out of control, both in the high places and in the streets. It’s time for the church to stand, step into the spiritual realm, and fight.</p>
<p class="tx">We are taught in God’s Word that the weapons of our warfare are not carnal but mighty through God to the pulling down of strongholds. During this season, when the church has gone into retreat and fallen silent, we need to pray that God will raise up an army of believers—an exceeding great army—that will go to war for the souls of this world. The harvest is plentiful, but the laborers are few. We need to suit up and boot up and take the war to the enemy in the spiritual realm. It’s time, friends. As we journey through this together, let us all be reminded to pray without ceasing, see all things through a spiritual lens, and glorify the Father in all we do. For that, please join me in prayer:</p>
<div class="bkt">
<p class="ext"><i>Father, Lord, we thank You so much for Your Word. We thank You for proving that Your Word is true, Lord, and for revealing that we can look to Your Word at any time and find You there. As we navigate these times of great uncertainty and chaos—when so many call good, evil, and evil, good—oh Lord, we ask You to resurrect Your church. Breathe Your Spirit into these dry bones and raise up an exceeding great army of soldiers for Christ. Lord, guide us and teach us all Your ways and only Your ways. Your Word says that Your people are destroyed for a lack of knowledge. Give us Your knowledge and wisdom, oh God, and teach us to stand and fight according to Your Word—fully knowing</i> <span epub:type="pagebreak" id="page_vi" title="vi"><i>that no weapon formed against us will ever prosper. May we be reminded every day to put on the whole armor of God and do all to stand against the wiles of the devil in this evil day, ensuring You receive all glory and honor. In Jesus’ name, amen.</i></span></p>
</div>
<p class="txr">—T<span class="small">AISHA</span> L<span class="small">OCKE</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?756865f0